import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { ErrorDetailInterface } from '../../interface/response-generic.interface';

@Injectable({
  providedIn: 'root'
})
export class ManejoErroresService {

  constructor() { }

  handleErrors(error: HttpErrorResponse): Observable<never> {
    let errorDetail: ErrorDetailInterface[] = [];
    try {
      // Errores de conexión / CORS (status 0) siempre en español
      if (error.status === 0) {
        errorDetail.push({ errorCode: '0', errorMessage: 'No se pudo conectar con el servidor' });
        return throwError(() => errorDetail);
      }

      // Intentar extraer mensaje del cuerpo de la respuesta del servidor
      if (error.error && typeof error.error === 'object' && !(error.error instanceof ProgressEvent)) {
        if (Array.isArray(error.error.errors)) {
          errorDetail = error.error.errors;
        } else {
          const rawMsg = error.error.errorMessage || error.error.message;
          if (rawMsg) {
            // Si el servidor envía mensajes técnicos o genéricos por código HTTP,
            // no los agregamos para que tome el mensaje amigable por código de estado
            const esGenerico =
              (error.status === 401 && (/autorizado/i.test(rawMsg) || /unauthori[sz]ed/i.test(rawMsg) || /unauthenticated/i.test(rawMsg))) ||
              (error.status === 403 && (/forbidden/i.test(rawMsg) || /prohibido/i.test(rawMsg))) ||
              (error.status === 404 && (/not found/i.test(rawMsg) || /no encontrad/i.test(rawMsg))) ||
              (error.status === 500 && (/server error/i.test(rawMsg) || /error interno/i.test(rawMsg)));

            if (!esGenerico) {
              errorDetail.push({ errorCode: error.status.toString(), errorMessage: rawMsg });
            }
          }
        }
      }

      // Mensaje por defecto en español según código de estado
      if (errorDetail.length === 0) {
        let msg = 'Ocurrió un error inesperado';
        if (error.status === 401) {
          msg = 'Usuario o clave incorrecto';
        } else if (error.status === 403) {
          msg = 'No tiene permisos para realizar esta acción';
        } else if (error.status === 404) {
          msg = 'Recurso no encontrado';
        } else if (error.status === 500) {
          msg = 'Error interno del servidor';
        }
        errorDetail.push({ errorCode: error.status.toString(), errorMessage: msg });
      }
    } catch (e) {
      errorDetail.push({ errorCode: '500', errorMessage: 'Ocurrió un error inesperado' });
    }
    return throwError(() => errorDetail);
  }
}
